/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export default () => {
    return (
        <div className='row'>
            <h2>Hello world</h2>
        </div>
    );
};
